"use strict";

var _classCallCheck = require("/app/node_modules/@babel/runtime/helpers/classCallCheck");

Object.defineProperty(exports, "__esModule", {
  value: true
});
/* tslint:disable:no-console */

var StaticConfig = function StaticConfig() {
  _classCallCheck(this, StaticConfig);
};

StaticConfig.LEAST_LEVEL_ENV = "LOG_LEVEL";
StaticConfig.LOG_FORMAT_ENV = "LOG_FORMAT";
StaticConfig.LOG_METADATA_ENV = "LOG_METADATA";
StaticConfig.REEVALUATE_CONFIG_AFTER_MS = 150;

StaticConfig.DEFAULT_LOG_FN = function (msg) {
  return console.error(msg);
};

exports.StaticConfig = StaticConfig;